import { parseAsInteger, parseAsString, parseAsStringLiteral } from 'nuqs';

const optionalString = parseAsString;

export const parseAsSearchName = parseAsString.withDefault('');
export const parseAsPage = parseAsInteger.withDefault(1);
export const parseAsSortField = parseAsString.withDefault('');
export const parseAsSortOrder = parseAsStringLiteral([
  'asc',
  'desc',
]).withDefault('asc');

export const benefitsListParsers = {
  name: parseAsSearchName,
  supplierid: optionalString,
  country: optionalString,
  city: optionalString,
  type: optionalString,
  activityType: optionalString,
  page: parseAsPage,
  sortField: parseAsSortField,
  sortOrder: parseAsSortOrder,
} as const;

export const circuitsListParsers = {
  name: parseAsSearchName,
  countries: optionalString,
  durationDays: optionalString,
  durationNights: optionalString,
  page: parseAsPage,
  sortField: parseAsSortField,
  sortOrder: parseAsSortOrder,
} as const;

export const suppliersListParsers = {
  name: parseAsSearchName,
  country: optionalString,
  city: optionalString,
} as const;

export const distributorCircuitsTabOptions = [
  'myCatalogue',
  'toBeValidated',
  'refused',
  'myEditableCircuits',
] as const;

export type DistributorCircuitsTab =
  (typeof distributorCircuitsTabOptions)[number];

export const distributorCircuitsTabParser = parseAsStringLiteral(
  distributorCircuitsTabOptions,
).withDefault('myCatalogue');

export const distributorCircuitsListParsers = {
  name: parseAsSearchName,
  supplierid: optionalString,
  country: optionalString,
  durationDays: optionalString,
  durationNights: optionalString,
  circuits: distributorCircuitsTabParser,
} as const;
